import { IExpression } from "@@expressions";
import { InputFieldModel } from "./InputFieldModel";
import { StackContainerDirection } from "./StackContainerDirection";
import { VarAssignExpression } from "../../ExpressionsModule/Models/VarAssignExpression";

export interface IHasLookupField {
  // Called to obtain the value of the field, and also set the value back when item selected
  Value?: VarAssignExpression;
  // Called to obtain the item (value and label), and also set the item back when item selected.
  Item?: IExpression;
  // Will get an $event with text inside to search for available items, should return list of items with key and label
  Items: IExpression;
  // The field in the item to use as the value
  ItemKeyField: string;
  // The label text template for the item, can use {fieldName} to display other fields in the item, if not set, will use ItemKeyField as label
  ItemLabel: string;
  // Will get an $event being the selected item
  ItemSelected?: IExpression;
}

export type InputSelectModel = InputFieldModel & IHasLookupField & {
  IsMultiSelect?: boolean;
  Typeahead?: boolean;
  SelectVariant?: InputSelectVariant;
  SelectDirection?: StackContainerDirection;
  Values?: VarAssignExpression;
};

export enum InputSelectVariant {
  Dropdown = "Dropdown",
  ButtonGroup = "ButtonGroup",
  RadioGroup = "RadioGroup",
}

export { StackContainerDirection };
